var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87505 4.8752H2.8938L5.9438 1.8252C6.18755 1.58145 6.18755 1.18145 5.9438 0.937695C5.70005 0.693945 5.3063 0.693945 5.06255 0.937695L0.943799 5.05645C0.700049 5.3002 0.700049 5.69395 0.943799 5.9377L5.06255 10.0564C5.3063 10.3002 5.70005 10.3002 5.9438 10.0564C6.18755 9.8127 6.18755 9.41895 5.9438 9.1752L2.8938 6.1252H9.87505C10.2188 6.1252 10.5 5.84395 10.5 5.5002C10.5 5.15645 10.2188 4.8752 9.87505 4.8752Z",
    fill: "#223E7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.78b1479369222791c8ab3c045a91e951.svg";
export { ForwardRef as ReactComponent };